// =========================================================================
// 1. POPUP STYLES & AUTO CLAIM POPUP
// =========================================================================
(function() {
    try {
        var style = document.createElement('style');
        style.innerHTML = `
            .salepify-popup__search-wrapper {
                display: none !important;
            }

            .salepify-popup-item__qty-badge,
            .salepify-popup-product-img svg,
            .salepify-popup-product-img [class*="icon"],
            .salepify-popup-product-img [class*="zoom"] {
                display: none !important;
            }

            .salepify-popup-item__action {
                display: flex !important;
                justify-content: flex-start !important;
                width: 100% !important;
                margin-top: 6px !important;
            }

            .salepify-popup-item__action .salepify-popup-item__select-btn,
            .salepify-popup-item__action .salepify-popup-item__selected-btn,
            button.salepify-popup-item__select-btn,
            button.salepify-popup-item__selected-btn {
                align-items: center !important;
                justify-content: center !important;
                width: fit-content !important;
                min-width: 70px !important;
                height: 30px !important;
                min-height: 0 !important;
                max-height: 30px !important;
                padding: 0 14px !important;
                font-size: 14px !important;
                font-weight: 500 !important;
                line-height: 30px !important;
                border-radius: 4px !important;
                box-sizing: border-box !important;
                transition: all 0.2s ease !important;
            }
            .salepify-popup-item__select-btn:hover {
                opacity: 0.85 !important;
            }
        `;
        document.head.appendChild(style);
    } catch (e) {}

    try {
        var checkExist = setInterval(function() {
            try {
                var headerTitle = document.querySelector('.salepify-embed-widget__header-title');

                if (headerTitle) {
                    var computedFont = window.getComputedStyle(headerTitle).fontFamily;

                    if (computedFont) {
                        var fontStyle = document.createElement('style');
                        fontStyle.innerHTML =
                            ".salepify-embed-widget__header-text { " +
                            "    font-family: " + computedFont + " !important; " +
                            "}";
                        document.head.appendChild(fontStyle);
                    }

                    clearInterval(checkExist);
                }
            } catch (innerError) {
                clearInterval(checkExist);
            }
        }, 500);

        setTimeout(function() { clearInterval(checkExist); }, 10000);
    } catch (e) {}

    try {
        function updateClaimButtons() {
            try {
                var buttons = document.querySelectorAll('.salepify-popup-item__select-btn');
                buttons.forEach(function(btn) {
                    if (btn.textContent.trim().toUpperCase() === 'CLAIM') {
                        btn.textContent = 'Select';
                    }
                });
            } catch (e) {}
        }

        updateClaimButtons();

        var observer = new MutationObserver(function(mutations) {
            try {
                var hasAddedNodes = mutations.some(function(m) {
                    return m.addedNodes && m.addedNodes.length > 0;
                });
                if (hasAddedNodes) {
                    updateClaimButtons();
                }
            } catch (e) {}
        });

        observer.observe(document.body, { childList: true, subtree: true });
    } catch (e) {}

    try {
        var isAutoClaiming = false;

        document.addEventListener('click', function(e) {
            try {
                var selectBtn = e.target.closest('.salepify-popup-item__select-btn');
                if (!selectBtn) return;

                var btnText = selectBtn.textContent.trim().toUpperCase();
                if (btnText === 'UNSELECT' || isAutoClaiming) return;

                isAutoClaiming = true;

                setTimeout(function() {
                    try {
                        var popupModal = selectBtn.closest('.salepify-popup-wrapper, .salepify-popup');
                        var ruleContainer = selectBtn.closest('[rule-id]');
                        var ruleId = ruleContainer ? ruleContainer.getAttribute('rule-id') : null;

                        var claimBtn = popupModal ? popupModal.querySelector('.salepify-popup__claim-button') : null;

                        if (claimBtn && !claimBtn.hasAttribute('disabled')) {
                            claimBtn.click();
                        } else if (ruleId && window.tlFreeGiftOffer && window.tlFreeGiftOffer.popupWidget) {
                            window.tlFreeGiftOffer.popupWidget.handleClaimGift(Number(ruleId));
                        }
                    } catch (err) {
                    } finally {
                        setTimeout(function() {
                            isAutoClaiming = false;
                        }, 1500);
                    }
                }, 250);
            } catch (err) {}
        });
    } catch (e) {}
})();

// =========================================================================
// 2. CUSTOM SELECT BUTTON RESIZE CSS
// =========================================================================
(function () {
    try {
      var style = document.createElement('style');
      style.id = 'salepify-select-btn-override';
      style.textContent = [
        '.salepify-embed-widget__select-button {',
        '  width: auto !important;',
        '  min-width: unset !important;',
        '  max-width: 120px !important;',
        '  height: 32px !important;',
        '  min-height: unset !important;',
        '  padding: 4px 10px !important;',
        '  font-size: 13px !important;',
        '  line-height: 1.2 !important;',
        '}'
      ].join('\n');
      document.head.appendChild(style);
    } catch (e) {
      console.warn('[Salepify] Failed to resize select button:', e);
    }
})();

// =========================================================================
// 3. SELECT BUTTON ADD GIFT & CHẶN HOÀN TOÀN RELOAD
// =========================================================================
(function () {
  if (window.__salepifySelectAddsToCart) return;
  window.__salepifySelectAddsToCart = true;

  var SELECTOR = ".salepify-embed-widget__select-button";
  var busyButtons = new WeakSet();

  function getEmbed() {
    return window.tlFreeGiftOffer && window.tlFreeGiftOffer.embedWidget;
  }

  function getGiftId(button) {
    var giftItem = button.closest(".salepify-embed-widget__gift-item");
    var actions = button.closest(".salepify-embed-widget__gift-item-actions");
    return (giftItem && giftItem.getAttribute("gift-id")) ||
      (actions && actions.getAttribute("gift-id"));
  }

  function markButtonsAsTypeButton() {
    document.querySelectorAll('.salepify-embed-widget__item button, ' + SELECTOR).forEach(function (btn) {
      btn.setAttribute("type", "button");
    });
  }

  markButtonsAsTypeButton();
  new MutationObserver(markButtonsAsTypeButton).observe(document.body, {
    childList: true,
    subtree: true
  });

  // HÀM REFRESH CART AJAX (KHÔNG RELOAD TRANG)
  async function refreshCartWithoutReload() {
    try {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
      
      // 1. Cập nhật số lượng giỏ hàng trên Header
      var cartRes = await fetch(root + "cart.js", {
        credentials: "same-origin",
        headers: { "Content-Type": "application/json" }
      });
      var cart = await cartRes.json();

      var countSelectors = [
        '.cart-count',
        '[data-cart-count]',
        '.cart-count-bubble',
        '.cart-count-bubble span',
        '#CartCount',
        '.header__cart-count'
      ];
      document.querySelectorAll(countSelectors.join(',')).forEach(function(el) {
        el.textContent = cart.item_count;
        if (el.classList.contains('cart-count-bubble') && cart.item_count > 0) {
          el.classList.remove('hidden');
        }
      });

      // theme side cart (#cart): ajaxCart.load() without data reuses cached HTML, so pass fresh section
      if (window.ajaxCart && typeof window.ajaxCart.load === 'function') {
        var sideRes = await fetch(root + '?sections=side-cart');
        window.ajaxCart.load({ sections: await sideRes.json() }, true);
      }

      // 2. Cập nhật Cart Drawer (Dawn & OS 2.0 themes)
      var cartDrawer = document.querySelector('cart-drawer');
      var cartItems = document.querySelector('cart-drawer-items, cart-items');
      if (cartDrawer) {
        cartDrawer.classList.remove('is-empty');
        cartDrawer.removeAttribute('hidden');

        var sectionsToRender = [];
        if (typeof cartDrawer.getSectionsToRender === 'function') {
          sectionsToRender = cartDrawer.getSectionsToRender();
        } else if (cartItems && typeof cartItems.getSectionsToRender === 'function') {
          sectionsToRender = cartItems.getSectionsToRender();
        } else {
          sectionsToRender = [
            { id: 'cart-drawer', section: 'cart-drawer', selector: '.drawer__inner' },
            { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }
          ];
        }

        var sectionIds = sectionsToRender.map(function(s) { return s.section || s.id; }).filter(Boolean).join(',');
        if (sectionIds) {
          var sectionsRes = await fetch(root + '?sections=' + sectionIds);
          var sectionHtmlMap = await sectionsRes.json();

          if (typeof cartDrawer.renderContents === 'function') {
            cartDrawer.renderContents({ sections: sectionHtmlMap });
          } else {
            sectionsToRender.forEach(function(s) {
              var html = sectionHtmlMap[s.section];
              if (!html) return;
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var target = (s.id ? document.getElementById(s.id)?.querySelector(s.selector) : null) || 
                           document.querySelector(s.selector) || 
                           (s.id ? document.getElementById(s.id) : null);
              var source = (s.id ? doc.getElementById(s.id)?.querySelector(s.selector) : null) || 
                           doc.querySelector(s.selector) || 
                           (s.id ? doc.getElementById(s.id) : null);
              if (target && source) target.innerHTML = source.innerHTML;
            });
          }
        }

        if (typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        } else {
          cartDrawer.classList.add('active', 'animate');
        }
      }

      // 3. Dispatch các Custom Event chuẩn cho các theme khác (Prestige, Impulse, Focal, Eurus,...)
      document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart: cart }, bubbles: true }));
      document.dispatchEvent(new CustomEvent("cart:refresh", { detail: { cart: cart, open: true }, bubbles: true }));
      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { detail: { cart: cart, open: true }, bubbles: true }));
      document.dispatchEvent(new CustomEvent("cart:build", { bubbles: true }));
      document.dispatchEvent(new CustomEvent("on:cart:change", { bubbles: true }));
      window.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart: cart } }));

      if (window.Alpine && window.Alpine.store && window.Alpine.store('xMiniCart')) {
        window.Alpine.store('xMiniCart').reLoad();
      }
    } catch (err) {
      console.warn('[Salepify] Refresh UI error:', err);
    }
  }

  // GHI ĐÈ TRỰC TIẾP HÀM REFRESH CỦA APP ĐỂ KHÔNG BAO GIỜ RELOAD
  window.tlGetRefreshCartFunc = function (afterRefreshCallback) {
    return async function () {
      await refreshCartWithoutReload();
      if (typeof afterRefreshCallback === "function") {
        try { await afterRefreshCallback(); } catch(e) {}
      }
    };
  };

  function preventAppReload() {
    if (window.tlFreeGiftOffer) {
      window.tlFreeGiftOffer.refreshCartFunc = async function () {
        await refreshCartWithoutReload();
      };
      window.tlFreeGiftOffer.refreshCartContent = async function () {
        await refreshCartWithoutReload();
      };
    }
  }

  preventAppReload();
  var interval = setInterval(preventAppReload, 200);
  setTimeout(function() { clearInterval(interval); }, 15000);

  // Chặn submit form
  document.addEventListener("submit", function (event) {
    var submitter = event.submitter;
    if (submitter && submitter.closest && submitter.closest(SELECTOR)) {
      event.preventDefault();
      event.stopPropagation();
    }
  }, true);

  // Click chọn quà
  document.addEventListener("click", function (event) {
    var button = event.target.closest(SELECTOR);
    if (!button || button.disabled) return;

    event.preventDefault();
    event.stopPropagation();

    var embed = getEmbed();
    var widgetItem = button.closest(".salepify-embed-widget__item");
    var giftId = getGiftId(button);
    if (!embed || !widgetItem || !giftId) return;

    var ruleId = Number(widgetItem.getAttribute("rule-id"));
    var displayRule = embed.getDisplayRuleById(ruleId);
    if (!displayRule) return;

    preventAppReload();

    if (displayRule.is_gift_qty_fixed) {
      embed.handleSelectGift(button, Number(giftId));
    } else {
      embed.handleAddGift(button, Number(giftId));
    }

    claimSelectedGift(button);
  }, true);

  async function claimSelectedGift(button) {
    var embed = getEmbed();
    var offer = window.tlFreeGiftOffer;
    if (!embed || !offer || busyButtons.has(button)) return;

    var widgetItem = button.closest(".salepify-embed-widget__item");
    if (!widgetItem) return;

    var ruleId = Number(widgetItem.getAttribute("rule-id"));
    var blockIndex = widgetItem.getAttribute("index");
    var blockKey = ruleId + "-" + blockIndex;
    var giftId = String(getGiftId(button) || "");
    if (!ruleId || !giftId) return;

    var displayRule = embed.getDisplayRuleById(ruleId);
    if (!displayRule) return;

    var selectedGifts = embed.selectedGiftQuantitiesByBlockId.get(blockKey) || {};
    var qty = selectedGifts[giftId] || 0;
    var addedGifts = offer.ruleIdMapGifts.get(ruleId) || [];
    var toast = (embed.getTranslationByRuleId(ruleId) || {}).toast || {};

    busyButtons.add(button);
    button.disabled = true;

    try {
      preventAppReload();

      if (qty > 0) {
        var items = embed.getItemsToAdd({ [giftId]: qty }, displayRule);
        if (!items.length) return;

        var addCartRes = await offer.handleAddGifts(
          items,
          displayRule.discount_code ? [displayRule.discount_code] : [],
          []
        );

        if (addCartRes.status !== 200) {
          if (embed.showToast) embed.showToast(toast.err_when_claim);
          return;
        }
      } else {
        var updates = {};
        addedGifts.forEach(function (gift) {
          if (String(gift.id) === giftId) updates[gift.key] = 0;
        });
        if (!Object.keys(updates).length) return;
        await embed.ajaxAPI.cartUpdate({ updates: updates });
      }

      delete selectedGifts[giftId];
      embed.selectedGiftQuantitiesByBlockId.set(blockKey, selectedGifts);

      // CẬP NHẬT CART BẰNG AJAX THAY VÌ GỌI RELOAD CỦA APP
      await refreshCartWithoutReload();
      // re-read cart into app state, else claimedCount stays stale and re-click adds a duplicate gift
      await offer.updateCartData();
    } catch (error) {
      console.error("Select button add gift failed:", error);
      if (embed.showToast) embed.showToast(toast.err_when_claim);
    } finally {
      busyButtons.delete(button);
      button.disabled = false;
    }
  }
})();
